'use client';

import clsx from 'clsx';
import React from 'react';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';

import styles from './LightClientAsset.module.scss';

import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

type ClientAssetProps = {
    id: string;
    className?: string;
    title?: string;
};

const LightClientAsset: React.FC<ClientAssetProps> = ({ id, className, title }) => (
    <div className={clsx(styles.root, className)}>
        <LiteYouTubeEmbed
            poster="maxresdefault"
            id={id}
            title={title}
            playlist={false}
            playerClass={styles.playerBtn}
            params="controls=1&start=0&modestbranding=2&rel=0&showinfo=0"
        />
    </div>
);

export default LightClientAsset;
